/** @readonly Campaign / business service routes (super admin only until v2 mapped) */
export const CAMPAIGN_ROUTES = Object.freeze({
  DECISION_BOARD: '/r/campaign/campaignDecisionBoard',
  LIST: '/r/campaign/list',
  CHECKLIST: '/r/checklist/campaigns',
  BUSINESS_FUNCTIONS: '/r/business-functions',
});
